import { message } from 'antd';
import { makeAutoObservable, runInAction } from 'mobx';
import { InventoryService, Supplier, PagedSupplierRequest } from '@services';
import { EntityDto } from '@services';

class SupplierStore {
  suppliers: Map<string, Supplier> = new Map();
  supplier: Supplier | undefined;
  skipCount: number = 0;
  currentPage: number = 1;
  totalCount: number = 0;
  loading: boolean = false;
  maxResultCount: number = 15;

  constructor() {
    makeAutoObservable(this);
  }

  async getAll(request: PagedSupplierRequest) {
    this.setLoading(true);
    try {
      const result = await InventoryService.getAllSuppliers(request);
      runInAction(() => {
        this.suppliers.clear();
        result.items.forEach((x) => this.suppliers.set(x.id, x));
        this.totalCount = result.totalCount;
      });
    } catch (error) {
      console.error(error);
    }
    this.setLoading(false);
  }

  async get(entityDto: EntityDto<string>) {
    this.setLoading(true);
    try {
      const result = await InventoryService.getSupplier(entityDto);
      runInAction(() => {
        this.supplier = result;
      });
    } catch (error) {
      console.error(error);
    }
    this.setLoading(false);
  }

  async create(request: any) {
    try {
      const result = await InventoryService.createSupplier(request);
      runInAction(() => {
        this.suppliers.set(result.id, result);
        this.totalCount += 1;
      });
      message.success({ content: 'Supplier created successfully!' });
    } catch (error) {
      console.error(error);
    }
  }

  async update(request: any) {
    try {
      const result = await InventoryService.updateSupplier(request);
      runInAction(() => {
        this.suppliers.set(result.id, result);
        this.supplier = result;
      });
      message.success({ content: 'Supplier updated successfully!' });
    } catch (error) {
      console.error(error);
    }
  }

  async delete(entityDto: EntityDto<string>) {
    try {
      await InventoryService.deleteSupplier(entityDto);
      runInAction(() => {
        this.suppliers.delete(entityDto.id);
        this.totalCount -= 1;
      });
      message.success({ content: 'Supplier deleted successfully!' });
    } catch (error) {
      console.error(error);
    }
  }

  setLoading = (value: boolean) => {
    runInAction(() => {
      this.loading = value;
    });
  };

  handlePageChange = (pagination: any) => {
    runInAction(() => {
      this.maxResultCount = pagination.pageSize;
      this.skipCount = (pagination.current - 1) * pagination.pageSize;
      this.currentPage = pagination.current;
    });
  };

  setSkipCount = (value: number) => {
    runInAction(() => {
      this.skipCount = value;
    });
  };

  setCurrentPage = (value: number) => {
    runInAction(() => {
      this.currentPage = value;
    });
  };
}

export default SupplierStore;
